/**
 * Modal — native <dialog>
 * Replaces Foundation Reveal with native dialog element.
 * Uses data-open="<id>" to open and data-close to close.
 */

function init() {
  // Open triggers: [data-open="dialogId"]
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (!opener) return;

    e.preventDefault();
    const dialogId = opener.getAttribute('data-open');
    const dialog = document.getElementById(dialogId);

    if (dialog && dialog.tagName === 'DIALOG') {
      dialog.showModal();
    }
  });

  // Close triggers: [data-close] inside a <dialog>
  document.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-close]');
    if (!closer) return;

    const dialog = closer.closest('dialog');
    if (dialog) {
      e.preventDefault();
      dialog.close();
    }
  });

  // Close on backdrop click (click on <dialog> itself, not its content)
  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  });
}

// Auto-init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
